// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c868af2c","453":"0986bb10","732":"0b6d3061","977":"9852b6c5"}[chunkId] + ".chunk.js";
};